import app from 'app';
import _ from 'lodash';
import templateUrl from './settingsNav.html';
import './settingsNav.scss';

import { logEvent, eventCategories } from 'helpers/analytics';

function SettingsNav($state, PhiAuthorization) {
  const Nav = this;

  Nav.analyticsTrack = section => {
    logEvent('navClicked', {
      category: eventCategories.SETTINGS,
      section
    });
  };

  Nav.goToInviteAccess = function() {
    Nav.analyticsTrack('Manage family access');
    $state.go('SettingsFamilyAuthorize', {
      dependentId: _.get(Nav, 'agedDependents[0].id')
    });
  };

  Nav.isInviteAccessActive = function() {
    return $state.includes('SettingsFamilyAuthorize');
  };

  Nav.$onInit = () => {
    Nav.isSubscriber =
      Nav.currentUser.user.id === Nav.currentSponsorship.subscriber.id;
    if (Nav.isSubscriber) {
      Nav.agedDependents = Nav.planMemberships.coveredMembersOver13.filter(
        member => member.id !== Nav.currentUser.user.id
      );
    } else {
      PhiAuthorization.getAuthorizationsGrantedByLoggedInDependentToPrimary(
        Nav.currentSponsorship,
        Nav.currentUser
      ).then(authorizations =>
        _.set(Nav, 'familyAuthorizations', authorizations)
      );
    }
  };
}

app.component('settingsNav', {
  bindings: {
    isSubscriber: '<',
    planMemberships: '<',
    currentSponsorship: '<',
    currentUser: '<',
    cob: '<'
  },
  controller: SettingsNav,
  controllerAs: 'Nav',
  templateUrl
});

export default 'settingsNav';
